var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUniversalType2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 63,
    viewBox: "0 0 58 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.549805,
    width: 58,
    height: 61.9,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9557 24.3926L23.0046 24.3926C23.6308 24.418 24.1259 24.9299 24.1259 25.5527L24.1259 42.1035C24.1259 42.7417 23.6046 43.2646 22.9557 43.2646C22.3068 43.2646 21.7855 42.7417 21.7855 42.1035L21.7855 25.5537C21.7855 24.9147 22.3066 24.3926 22.9557 24.3926Z",
    stroke: "#0D4248",
    strokeWidth: 1.17
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2609 19.7346C29.9619 19.7346 30.6259 20.3799 30.6259 21.3015L30.6259 41.6978C30.6259 42.6184 29.9617 43.2646 29.2609 43.2646C28.5602 43.2646 27.8959 42.6184 27.8959 41.6978L27.8959 21.3027C27.8959 20.3806 28.5604 19.7346 29.2609 19.7346Z",
    stroke: "#0D4248",
    strokeWidth: 1.17
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7609 17.136L35.811 17.136C36.4476 17.1701 37.1259 17.851 37.1259 18.928L37.1259 41.4712C37.1259 42.5754 36.4113 43.2646 35.7609 43.2646C35.1106 43.2646 34.3959 42.5754 34.3959 41.4712L34.3959 18.9293C34.3959 17.8241 35.1104 17.136 35.7609 17.136Z",
    stroke: "#0D4248",
    strokeWidth: 1.17
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20.4502V46.4502H42",
    stroke: "#0D4248",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversalType2);
export default __webpack_public_path__ + "static/media/universal-type2.c3c30bb3069827ac2389bdee97a9a906.svg";
export { ForwardRef as ReactComponent };